<p-multiSelect
    [id] = "id()"
    [ngModel]="isLoading() ? [] : selectedProductCategoryReportKeys()"

    [options]="options()"
    optionLabel="productCategoryReportName"
    optionValue="productCategoryReportKey"
    dataKey="productCategoryReportKey"
    
    [placeholder]="isLoading() ? 'Loading products...' : placeHolder()"
    [loading]="isLoading()"
    [showClear]="true"

    [disabled]="isDisabled()"
    [invalid]="isInvalid()"

    (ngModelChange)="onModelChange($event)"
    (onBlur)="blur.emit()"
    
    fluid
    >
</p-multiSelect>
